import { render, staticRenderFns } from "./WikiPagePartialEdit.vue?vue&type=template&id=241ef4ae"
import script from "./WikiPagePartialEdit.vue?vue&type=script&lang=ts"
export * from "./WikiPagePartialEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports